import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import { SIDEBAR_MARKET_LOCATIONS_QUERY } from './query-definition';
import { SidebarMarketLocationsQuery, SidebarMarketLocationsQueryVariables } from '../../../generated/graphql';

/**
 * Queries the server for a number of marketLocations
 * all available marketLocations will be returned.
 * @param options
 */
export const useSidebarMarketLocationsQuery = (
  options?: QueryHookOptions<SidebarMarketLocationsQuery, SidebarMarketLocationsQueryVariables>,
): QueryResult<SidebarMarketLocationsQuery, SidebarMarketLocationsQueryVariables> =>
  useQuery<SidebarMarketLocationsQuery, SidebarMarketLocationsQueryVariables>(SIDEBAR_MARKET_LOCATIONS_QUERY, options);
